import React, { useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { ReactComponent as StarIcon } from "images/star-icon.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-5.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-7.svg";

const HeaderRow = tw.div`flex justify-between items-center flex-col xl:flex-row`;
const Header = tw(SectionHeading)``;
const TabsControl = tw.div`flex flex-wrap bg-gray-200 px-2 py-2 rounded leading-none mt-12 xl:mt-0`;

const TabControl = styled.div`
  ${tw`cursor-pointer px-6 py-3 mt-2 sm:mt-0 sm:mr-2 last:mr-0 text-gray-600 font-medium rounded-sm transition duration-300 text-sm sm:text-base w-1/2 sm:w-auto text-center`}
  &:hover {
    ${tw`bg-gray-300 text-gray-700`}
  }
  ${props => props.active && tw`bg-primary-500! text-gray-100!`}
  }
`;

const TabContent = tw(motion.div)`mt-6 flex flex-wrap sm:-mr-10 md:-mr-6 lg:-mr-12`;
const CardContainer = tw.div`mt-10 w-full md:w-1/3 lg:w-1/4 sm:pr-10 md:pr-72 lg:pr-16 ml-5`;
const Card = tw(motion.a)`bg-gray-200 rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0`;
const CardImageContainer = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-40 w-[240px] xl:h-48 bg-center bg-cover p-[140px] relative rounded-t`}
`;
const CardRatingContainer = tw.div`leading-none absolute inline-flex bg-gray-100 bottom-0 left-0 ml-4 mb-4 rounded-full px-5 py-2 items-end`;
const CardRating = styled.div`
  ${tw`mr-1 text-sm font-bold flex items-end`}
  svg {
    ${tw`w-4 h-4 fill-current text-orange-400 mr-1`}
  }
`;

const CardHoverOverlay = styled(motion.div)`
  background-color: rgba(255, 255, 255, 0.5);
  ${tw`absolute inset-0 flex justify-center items-center`}
`;
const CardButton = tw(PrimaryButtonBase)`text-sm`;

const CardReview = tw.div`font-medium text-xs text-gray-600`;

const CardText = tw.div`p-4 text-gray-900`;
const CardTitle = tw.h5`text-lg font-semibold group-hover:text-primary-500`;
const CardContent = tw.p`mt-1 text-sm font-medium text-gray-600`;
const CardPrice = tw.p`mt-4 text-xl font-bold`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-64 w-64 opacity-15 transform translate-x-2/3 -translate-y-12 text-pink-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-80 w-80 opacity-15 transform -translate-x-2/3 text-primary-500`}
`;

export default ({
  heading = "Checkout the Menu",
  tabs = {
    Starters: [
      {
        imageSrc:
          "https://seeklogo.com/images/I/istanbul-teknik-universitesi-itu-logo-B6FC9F665B-seeklogo.com.png",
        title: "Istanbul Technical University (ITU)",
        content: "",

        url: "/itu"
      },
      
      {
        imageSrc:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSls8gaV0bs4lgcoFv_S-pmMUgczgAdM_YoBw&s",
        title: "Boğaziçi University",
        content: "",
        url: "/bogazici"
      },
      {
        imageSrc:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPWJP0qmbGE7KwW8tPayEPLXekubCe9EsR4A&s",
        title: "Sabancı University",
        content: "",
        url: "/sabanci"
      },
      {
        imageSrc:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1CPRTl3YOvEZq9hvjQlRIRuqBO1cdo7XXPw&s",
        title: "Marmara University",
        content: "",
        url: "/marmara"
      },
      {
        imageSrc:
          "https://m.media-amazon.com/images/I/61Aea4purkL._AC_UF894,1000_QL80_.jpg",
        title: "Stanford University",
        content: "",
        url: "/stanford"
      },
      {
        imageSrc:
          "https://pbs.twimg.com/profile_images/1588546395165921282/rtpSDIEw_400x400.jpg",
        title: "University  of Sheffield ",
        content: "",
        url: "/sheffield"
      },
      {
        imageSrc:
          "https://upload.wikimedia.org/wikipedia/en/thumb/0/04/Utoronto_coa.svg/640px-Utoronto_coa.svg.png",
        title: "University of Toronto (UofT) ",
        content: "",
        url: "/toronto"
      },
      {
        imageSrc:
          "https://img7.mynet.com.tr/egitim/university/logos/215913.png",
        title: "MEF University",
        content: "",
        url: "/mef"
      },
      {
        imageSrc:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQdEHVEx19ap9dWLWugZTJEPfCm5Fngplsj8g&s",
        title: "University of Manchester",
        content: "",
        url: "/manc"
      },
      {
        imageSrc:
          "https://alemnishokran.com/wp-content/uploads/2022/10/1592407509XnVvt.png",
        title: "Bahçeşehir University",
        content: "",
        url: "/bau"
      },
      {
        imageSrc:
          "https://upload.wikimedia.org/wikipedia/tr/c/cf/PiriReisUniversitesiLogo.png",
        title: "Pîrî Reis University",
        content: "",
        url: "/piri"
      },
      {
        imageSrc:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnrlDUeZvjjsNsDqpJR6dF5kNShgsy7Adxew&s",
        title: "Istanbul Bilgi University",
        content: "",
        url: "/bilgi"
      },
      {
        imageSrc:
          "https://upload.wikimedia.org/wikipedia/tr/9/92/Istanbul_Universitesi.png",
        title: "Istanbul University",
        content: "",
        url: "/istanbul"
      },
      {
        imageSrc:
          "https://uskudar.edu.tr/assets/kurumsal/logo/jpg/uskudar-universitesi-logo.jpg",
        title: "Üsküdar University ",
        content: "",
        url: "/uskudar"
      },
      {
        imageSrc:
          "https://upload.wikimedia.org/wikipedia/tr/7/7e/Beykent_Universitesi_Logo_Yeni.png",
        title: "İstanbul Beykent University",
        content: "",
        url: "/beykent"
      },
      {
        imageSrc:
          "https://qs-hub2.qs.com/wp-content/uploads/2021/10/211027114149am317273Poli-di-Torino-logo-200x2000-200x200.jpg",
        title: "Politecnico di Torino",
        content: "",
        url: "/torino"
      },
      {
        imageSrc:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqgzWYd-Jv2TAY2_YtlTy5kjY4BcokzuKzuQ&s",
        title: "Bangor University",
        content: "",
        url: "/bangor"
      },
      {
        imageSrc:
          "https://media.globaladmissions.com/media/school_logos/university-of-groningen_Fwhd7UH.png",
        title: "University of Groningen",
        content: "",
        url: "/gronigen"
      },
      {
        imageSrc:
          "https://upload.wikimedia.org/wikipedia/commons/d/db/Erasmus_University_Rotterdam_Stacked_logo_%28Colour%29.png",
        title: "Erasmus University Rotterdam",
        content: "",
        url: "/erasmus"
      },
      {
        imageSrc:
          "https://upload.wikimedia.org/wikipedia/it/3/3f/Universit%C3%A0_Luigi_Bocconi_-_logo_%28Italy%29.svg",
        title: "Bocconi University",
        content: "",
        url: "/baconni"
      },
      {
        imageSrc:
          "https://images.seeklogo.com/logo-png/48/2/hong-kong-polytechnic-university-logo-png_seeklogo-482688.png",
        title: "The Hong Kong Polytechnic University (PolyU)",
        content: "",
        url: "/honkong"
      },
      {
        imageSrc:
          "https://brand.ucsb.edu/sites/default/files/images/pages/Visual-Identity/Marks/Seal/navy-seal.gif",
        title: "University of California, Santa Barbara (UCSB)",
        content: "",
        url: "/santa"
      },
      {
        imageSrc:
          "https://www.timeshighereducation.com/cms-academic/sites/default/files/migrated_institution_logos/ytueng.png",
        title: "Yildiz Technical University(YTU)",
        content: "",
        url: "/ytu"
      },
      {
        imageSrc:
          "https://upload.wikimedia.org/wikipedia/commons/e/eb/Dogus_universitesi_yeni_logo.png",
        title: "Dogus University",
        content: "",
        url: "/dogus"
      },
      {
        imageSrc:
          "https://www.helios-h2020project.eu/sites/default/files/gbb-uploads/logo-iztech.png",
        title: "Izmir Institute of Technology IYTE",
        content: "",
        url: "/iyte"
      },
      {
        imageSrc:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmJQYtJMgNqbjOOGlRqtZ4dk_-GN5-E01e3Q&s",
        title: "Muğla Sıtkı Koçman University (MSKU)",
        content: "",
        url: "/msku"
      },
      {
        imageSrc:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRIUN8D3N9n3WGJvzFnef46WSkxlptW95dEJA&s",
        title: "Hacettepe University",
        content: "",
        url: "/hacettepe"
      },
      {
        imageSrc:
          "https://katsim.ku.edu.tr/wp-content/uploads/2022/05/1-3.png",
        title: "Koc University",
        content: "",
        url: "/koc"
      },
      {
        imageSrc:
          "https://theme.uzmandil.com/all//images/university/karadeniz_teknik_universitesi_pte_academic_hazirlik_atlama.png",
        title: "Black Sea Technical University",
        content: "",
        url: "/karadeniz"
      },
      {
        imageSrc:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_Twm4lMNkCHd_61EleU2K1XlpzmrMSPoTwA&s",
        title: "Aegean University",
        content: "",
        url: "/ege"
      },
      {
        imageSrc:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7krHkBLWLIrvQR-S84DNNwOKIBR9IM7gsdwQBBlpOLmHhAOiy6Bbso7kd8Bm629oWEYA&usqp=CAU",
        title: "Antalya Science University",
        content: "",
        url: "/antalya"
      },
      {
        imageSrc:
          "https://media.licdn.com/dms/image/v2/D4D0BAQFPyWWzO7ic6g/company-logo_200_200/B4DZTgyBmLHAAI-/0/1738937998868?e=2147483647&v=beta&t=h2MdWpyaQszkdeXByuCPwC-biHMmxhBo1aoGHvk8mT8",
        title: "Fatih Sultan Mehmet Foundation University",
        content: "",
        url: "/fsm"
      },
    ],
    Main: getRandomCards(),
    Soup: getRandomCards(),
    Desserts: getRandomCards()
  }
}) => {
  /*
   * To customize the tabs, pass in data using the `tabs` prop. It should be an object which contains the name of the tab
   * as the key and value of the key will be its content (as an array of objects).
   * To see what attributes are configurable of each object inside this array see the example above for "Starters".
   */
  const tabsKeys = Object.keys(tabs);
  const [activeTab, setActiveTab] = useState(tabsKeys[0]);

  return (
    <Container>
      <ContentWithPaddingXl>
        <HeaderRow>
          <Header>{heading}</Header>
     
        </HeaderRow>

        {tabsKeys.map((tabKey, index) => (
          <TabContent
            key={index}
            variants={{
              current: {
                opacity: 1,
                scale:1,
                display: "flex",
              },
              hidden: {
                opacity: 0,
                scale:0.8,
                display: "none",
              }
            }}
            transition={{ duration: 0.4 }}
            initial={activeTab === tabKey ? "current" : "hidden"}
            animate={activeTab === tabKey ? "current" : "hidden"}
          >
            {tabs[tabKey].map((card, index) => (
              <CardContainer key={index}>
                <Card className="group" href={card.url} initial="rest" whileHover="hover" animate="rest">
                  <CardImageContainer imageSrc={card.imageSrc}>
                    <CardHoverOverlay
                      variants={{
                        hover: {
                          opacity: 1,
                          height: "auto"
                        },
                        rest: {
                          opacity: 0,
                          height: 0
                        }
                      }}
                      transition={{ duration: 0.3 }}
                    >
               
                    </CardHoverOverlay>
                  </CardImageContainer>
                  <CardText>
                    <CardTitle>{card.title}</CardTitle>
                    <CardContent>{card.content}</CardContent>
                  </CardText>
                </Card>
              </CardContainer>
            ))}
          </TabContent>
        ))}
      </ContentWithPaddingXl>
      <DecoratorBlob1 />
      <DecoratorBlob2 />
    </Container>
  );
};

/* This function is only there for demo purposes. It populates placeholder cards */
const getRandomCards = () => {
  const cards = [
    {
      imageSrc:
        "https://upload.wikimedia.org/wikipedia/commons/c/ce/%C4%B0stanbul_Teknik_%C3%9Cniversitesi_Logo.jpg",
      title: "ITU",
      content: "baskan",
      url: "#"
    },
    {
      imageSrc:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbYCsfigv1tHswZG9wfUJJZDWEfCZNneaj0g&s",
      title: "Koc Universitesi",
      content: "Fried Mexican Beef",

      url: "#"
    },
    {
      imageSrc:
        "https://images.unsplash.com/photo-1565310022184-f23a884f29da?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
      title: "Carnet Nachos",
      content: "Chilli Crispy Nachos",

      url: "#"
    },
    {
      imageSrc:
        "https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
      title: "Guacamole Mex",
      content: "Mexican Chilli",

      url: "#"
    },
    {
      imageSrc:
        "https://images.unsplash.com/photo-1550461716-dbf266b2a8a7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
      title: "Chillie Cake",
      content: "Deepfried Chicken",

      url: "#"
    },
    {
      imageSrc:
        "https://images.unsplash.com/photo-1476224203421-9ac39bcb3327??ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
      title: "Nelli",
      content: "Hamburger & Fries",

      url: "#"
    },
    {
      imageSrc:
        "https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
      title: "Jalapeno Poppers",
      content: "Crispy Soyabeans",

      url: "#"
    }
  ];

  // Shuffle array
  return cards.sort(() => Math.random() - 0.5);
};
